/*eslint-disable no-unused-vars */
/*eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import {
  setClientType,
  setPortalType,
  setLoadingProgress,
} from '../../redux/app/appSlice';
import {
  resetSearchParams,
  resetNetworkList,
} from 'src/redux/member/findProviderSlice';

import PublicHeader from './header/PublicHeader';
import PublicFooter from './footer/PublicFooter';
import SecureHeader from './header/SecureHeader';
import SideNavBar from '../components/sidenavbar/sidenavbar';
import { getClientType } from '../utils/common';

import LoadingBar1 from './common/top-loading-bar/variant1';
import './common/top-loading-bar/loading-bar.scss';

import './common/skeleton/skeleton.css';
import { USER_TYPES } from 'src/constants';
import { resetSearchParams as claimsSearchParamsReset } from 'src/redux/member/memberClaimsSlice';
import { hexToRgb } from 'src/utils';

function MemberLayout(props) {
  console.log('rendering Member layout');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isThemeLoaded, branding } = useSelector((state) => state.theme);
  const { portalType, loadingProgress, loadingNum } = useSelector(
    (state) => state.app,
  );
  const { isStoreKeySet } = useSelector((state) => state.key);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const [isMenuDisabled, setMenuDisabled] = useState(null);
  const [isMember, setMember] = useState(false);
  const [isAppReady, setIsAppReady] = useState(false);
  const [getNotificationCount, setGetNotificationCount] = useState([]);

  const location = useLocation();
  //const isLoaded = isThemeLoaded && isStoreKeySet;

  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState(null);

  useEffect(() => {
    if (
      (isThemeLoaded && isStoreKeySet) ||
      location?.pathname.includes('/logout')
    ) {
      setIsAppReady(true);
    } else {
      setIsAppReady(false);
    }
  }, [isThemeLoaded, isStoreKeySet]);

  useEffect(() => {
    const unRegister = () => {
      const { pathname } = location;
      if (
        pathname !== '/member/find-provider' &&
        !pathname.includes('/member/doctor-details/', 0) &&
        !pathname.includes('/member/facility-details/', 0)
      ) {
        dispatch(resetSearchParams());
        dispatch(resetNetworkList());
      }
      if (
        pathname !== '/member/claims' &&
        pathname !== '/member/claim-details' &&
        pathname !== '/admin/claim-details'
      ) {
        dispatch(claimsSearchParamsReset());
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
    return unRegister;
  }, [location.pathname]);

  useEffect(() => {
    if (userData) {
      if (
        USER_TYPES.CLIENT === userData.UserType ||
        USER_TYPES.INSURER === userData.UserType
      ) {
        const redirectToUrl = '/admin/admin-dashboard';
        setRedirectUrl(redirectToUrl);
        setShouldRedirect(true);
      }
    }
  }, []);

  useEffect(() => {
    if (
      (!portalType || portalType === 'admin') &&
      location?.pathname.includes('/member')
    ) {
      dispatch(setPortalType('member'));
    }
    dispatch(setClientType(getClientType(window.innerWidth)));
    window.addEventListener('resize', handleResize, false);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (
      location.pathname.includes('/member') &&
      !location.pathname.includes('/admin')
    ) {
      const root = document.documentElement;
      if (branding && branding?.ThemeValues !== undefined) {
        branding.ThemeValues.forEach((element) => {
          root.style.setProperty(
            '--' + element.BrandingKey,
            element.BrandingValue,
          );
          root.style.setProperty(
            '--' + element.BrandingKey + '-rgb',
            hexToRgb(element.BrandingValue),
          );
        });
        root.style.setProperty('--HeadingFont', branding.HeadingFont);
        root.style.setProperty('--ParagraphFont', branding.ParagraphFont);
      }
      setMember(true);
    } else {
      setMember(false);
    }

    if (
      location.pathname.includes('/member/page/') &&
      location.search.includes('&newTab')
    ) {
      setMenuDisabled(false);
    } else {
      setMenuDisabled(true);
    }
  }, [location.pathname, branding, isLoggedIn]);

  const handleResize = () => {
    //setWindowWidth(window.innerWidth);
    dispatch(setClientType(getClientType(window.innerWidth)));
  };

  if (isMember) {
    return (
      <>
        {!isAppReady ? (
          <>
            <LoadingBar1
              progress={100 - loadingNum * 10}
              onLoaderFinished={() => {
                dispatch(setLoadingProgress(0));
              }}
            />
          </>
        ) : (
          <>
            <LoadingBar1
              progress={100 - loadingNum * 10}
              onLoaderFinished={() => {
                dispatch(setLoadingProgress(0));
              }}
            />

            <div className={isLoggedIn ? 'post-login' : ''}>
              {!isLoggedIn && <PublicHeader />}
              {isLoggedIn && !shouldRedirect && (
                <SecureHeader
                  getNotificationCount={getNotificationCount}
                  setGetNotificationCount={setGetNotificationCount}
                />
              )}
              <div
                className="content"
                style={{ minHeight: '250px' }}
                role="main"
              >
                {isLoggedIn && isMenuDisabled && (
                  <div className="dashboard-sidebar">
                    <SideNavBar
                      getNotificationCount={getNotificationCount}
                      setGetNotificationCount={setGetNotificationCount}
                    />
                  </div>
                )}
                {/*<PageLoader /> */}
                {props.children}
              </div>
              {!shouldRedirect && <PublicFooter />}
            </div>
            {shouldRedirect && <Navigate to={redirectUrl} />}
          </>
        )}
      </>
    );
  }
  return null;
}
export default MemberLayout;
